function teacherResponsive(parentContainer = document, className = "teacherResponsive") {

	const teacher = document.getElementById("teacher");
	const nameBar = document.getElementsByClassName("teacher-name-bar");
	const mobile = document.getElementsByClassName("teacher-name-mobile");
	const desktop = document.getElementsByClassName("teacher-name-desktop");
	let width = window.innerWidth;

	if (teacher == undefined || teacher == null) {
		return;
	}

	function hasClass(target, className) {
		return new RegExp('(\\s|^)' + className + '(\\s|$)').test(target.className);
	}

	let onresize = function () {
		width = window.innerWidth;

		if (width < 750) {
			
			if (!hasClass(nameBar[0], 'moved')) {
				nameBar[0].classList += ' moved';
				mobile[0].appendChild(nameBar[0]);
			}
		} else {
			if (hasClass(nameBar[0], 'moved')) {
				nameBar[0].classList.remove('moved');
				desktop[0].appendChild(nameBar[0]);
			}
		}
	}

	window.addEventListener("resize", onresize);

	onresize();

}

module.exports = teacherResponsive;


// WEBPACK FOOTER //
// ./resources/js/modules/teacher-responsive.js